import { Component, OnInit } from "@angular/core";
import { AppFlowService } from "../../services/app-flow.service";
import {
  AppState,
  Fields,
  Form,
  FormItem,
  FormValue,
  GroupField,
} from "../../models/app-state";
import { Router } from "@angular/router";
import { compact, reduce, values as _values } from "lodash";
import { PropostaService } from "../../services/proposta.service";
import { MessageService } from "../../services/message.service";
import { ReCaptchaV3Service } from "ng-recaptcha";
import parseISO from "date-fns/parseISO";
import isValid from "date-fns/isValid";
import format from "date-fns/format";
import { SessionStorageService } from "../../services/session-storage.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Campo, CampoCaptura, Proposta, Resposta } from "../../models/coleta";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { AppValidators } from "../../components/dynamic-inputs/util/validators";
import { NgxIndexedDBService } from "ngx-indexed-db";
import { INPUT_TYPES, PROPRIEDADES, STORAGE_KEYS } from "../../components/dynamic-inputs/util/constants";
import * as _ from "lodash";
import { ReRecaptchaSmileGoService } from "src/app/services/recaptcha-smilego.service";
import { concatMap, take } from "rxjs/operators"
import { concat } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { DialogComponent } from "src/app/components/dialog/dialog.component";
import { UrlParamsService } from "src/app/services/url-params.service";
import { parse } from "date-fns";
import { EnvConfig, ProductType } from "src/app/models/env-config";
import { CaptchaStorageService } from "src/app/services/captcha-storage.service";


@Component({
  selector: "app-review-form-page",
  templateUrl: "./review-form-page.component.html",
  styleUrls: ["./review-form-page.component.scss"],
})
export class ReviewFormPageComponent implements OnInit {
  durationInSeconds = 5;
  formData: any;
  errors = [];
  isLoading = false;
  images: any = [];
  productId: string;
  field: Campo = {};
  form: Form;
  formGroup: UntypedFormGroup;
  captureOpen = false;
  fieldsMap = {};

 loader: string = '';
  waitingTitle: string = '';
  waitingMessages: string[] = [];
  waitingObservation: string = "";
  alertOnPages: string[] = [];
  alertOnPagesMessages: Record<string, string> = {};
  captchaToken: string | null = '';

  constructor(
    private appFlowService: AppFlowService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private router: Router,
    fb: UntypedFormBuilder,
    private dbService: NgxIndexedDBService,
    private localStorageService: SessionStorageService,
    private propostaService: PropostaService,
    private messageService: MessageService,
    private snackBar: MatSnackBar,
    private recaptchaSmileGoService: ReRecaptchaSmileGoService,
    public dialog: MatDialog,
    private urlParams: UrlParamsService,
    private captchaStorageService: CaptchaStorageService
  ) {
    const envConfig = localStorageService.getEnvConfig();

    this.productId = envConfig.productId || "1";
    this.form = this.appFlowService.getAppState().form;
    this.loader = envConfig.waitingLoader || 'default';
    this.waitingTitle = envConfig.waitingTitle || '';
    this.waitingMessages = envConfig.waitingMessages || [];

    this.waitingObservation = this.getRandomMessage();

    const state = this.appFlowService.getAppState();

    this.formGroup = fb.group({});

    try{


      this.fieldsMap = Object.values(state.fields).reduce((prev, current) => {
        const value = current.fields.reduce((p, c) => {
          return { ...p, [c.codigo || ""]: c };
        }, {});
        return { ...prev, ...value };
      }, {} as any);

      Object.values(this.form).forEach((item) => {
        Object.values(item.value).forEach((formValue) => {
          const field = (this.fieldsMap as any)[formValue?.campoCodigo];
          const fieldValue = formValue.valor;
          const validations = AppValidators.getValidations(field);
          const formControl = new UntypedFormControl(fieldValue, validations);
          this.formGroup.addControl(field.codigo, formControl);
        });
      });
    }catch(err) {
      console.error("Erro ao carregar a página de revisão: ", err);
      console.error("AppState:", state);
      console.error("EnvConfig:", envConfig);
    }
    
  }

  get name(): string {
    if (this.formGroup.controls["pessoa.nome"]) {
      return this.formGroup.controls["pessoa.nome"].value?.split(" ")[0];
    }
    return "Olá";
  }

  getRandomMessage(): string{
    if(!this.waitingMessages) return "";
    const randomPosition: number = Math.round(Math.random() * this.waitingMessages.length);

    const randomMessage: string = this.waitingMessages[randomPosition];

    return randomMessage;
  }


  isValid(field: any): boolean {
    return this.formGroup.controls[field.campoCodigo]?.valid || false;
  }

  openSnackBar(message: string): void {
    this.snackBar.open(message, "", {
      duration: this.durationInSeconds * 1000,
    });
  }

  async submitForm(): Promise<void> {
    try {
      this.isLoading = true;
      const appState: AppState = this.appFlowService.getAppState();
      const envConfig = this.localStorageService.getEnvConfig();
      this.alertOnPages = envConfig.alertOnPages || [];
      this.alertOnPagesMessages = envConfig.alertOnPagesMessages || {};


      if (Array.isArray(this.alertOnPages) && this.alertOnPages.includes(appState.proposta?.etapaAtual.nome ?? '')) {
        const alertMessage = this.alertOnPagesMessages?.[appState.proposta?.etapaAtual.nome ?? ''];
        this.dialog.open(DialogComponent, {
          width: "250px",
          data: { title: "Atenção!", message: alertMessage },
        });
      }

      let respostas: any[] = await Promise.all(
        reduce(
          appState.form,
          (acc, value: FormItem) => {
            const formValues: Promise<any>[] = _values(value.value).map(
              async ({ campoCodigo, campoId, valor, tipo }) => {
                if (!valor) {
                  return undefined;
                }
                let fieldValue: any =
                  this.formGroup.getRawValue()[campoCodigo] || value;

                const campoDef = (this.fieldsMap as any)[campoCodigo] as Campo | undefined;
                const hasMask = campoDef?.atributos?.some(
                  (item) => item.propriedade === PROPRIEDADES.MASCARA
                );
                const deveRemoverMascara =
                  hasMask || tipo === INPUT_TYPES.ALFANUMERICO;
                if (deveRemoverMascara && typeof fieldValue === "string" && tipo !== "DATA") {
                  fieldValue = fieldValue.replace(/[^A-Za-z0-9]/g, "");
                  const ehCampoCnpj = campoCodigo === envConfig.nomeCampoCnpj;
                  if (tipo === INPUT_TYPES.ALFANUMERICO || ehCampoCnpj) {
                    fieldValue = fieldValue.toUpperCase();
                  }
                }

                  const dateRegex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/\d{4}$/;

                if (
                  fieldValue &&
                  typeof fieldValue === "string" &&
                  dateRegex.test(fieldValue) &&
                  fieldValue.length === 10
                ) {
                  const date: Date = parse(fieldValue, "dd/MM/yyyy", new Date());
                    if (isValid(date)) {
                      fieldValue = format(date, "yyyy-MM-dd");
                    }
                  }

                if (campoCodigo === "pessoa.renda.principal.valor") {
                  fieldValue = parseInt(valor, 10).toString();
                }

                if (tipo === "CAPTURA_IMAGEM") {
                  const campoCaptura: CampoCaptura = await this.appFlowService.getImageBase64(campoCodigo);
                  return {
                    campoCodigo,
                    campoId,
                    ordem: "0",
                    captura: true,
                    isPdf: campoCaptura.isPdf ? true : false,
                    valor: campoCaptura.base64,
                  };
                }
                return {
                  campoCodigo,
                  campoId,
                  ordem: "0",
                  valor: fieldValue,
                };
              }
            );
            return [...acc, ...formValues];
          },
          [] as Promise<any>[]
        )
      );

      respostas = respostas.filter((resposta) => resposta !== undefined);

      const smsField = this.appFlowService.getCampoByCodigo(envConfig.nomeCampoSms);

      if (smsField) {
        const phone = respostas.find(
          (item) => item.campoCodigo === envConfig.nomeCampoTelefone
        )?.valor;
        const ddd = respostas.find(
          (item) => item.campoCodigo === envConfig.nomeCampoDdd
        )?.valor;

        const smsValue = [ddd, phone].join("");
        respostas.push(
          ...[
            {
              campoId: smsField?.id,
              campoCodigo: smsField.codigo,
              ordem: "0",
              valor: smsValue,
            },
          ]
        );

      }

      const metadataField = this.appFlowService.getCampoByCodigo(envConfig.nomeCampoMetadados);

      if (
        metadataField &&
        !respostas.some(
          (resposta) => resposta.campoCodigo === envConfig.nomeCampoMetadados
        )
      ) {
        respostas.push({
          campoCodigo: metadataField.codigo,
          campoId: metadataField.id,
          valor: JSON.stringify({
            ...this.localStorageService.getSessionEntry(STORAGE_KEYS.METADATA),
            ...this.localStorageService.getSessionEntry(STORAGE_KEYS.POSITION),
          }),
          ordem: "0",
        });
      }

      // Evita o mesmo campo em mais de uma página do form
      respostas = this.dedupeRespostasByCampoId(respostas);

      let requestBody: any;

      if (this.isPreProposta()) {
        const origemField =
          this.appFlowService.getCampoByCodigo('proposta.origem');

        if (
          origemField &&
          !respostas.some(
            (resposta) => resposta.campoCodigo === 'proposta.origem',
          )
        ) {
          respostas.push({
            campoCodigo: origemField.codigo,
            campoId: origemField.id,
            valor: 'WHITELABEL',
            ordem: '0',
          });
        }

        const tokenIndicacaoCampo: Campo | undefined = this.appFlowService.getCampoByCodigo('pessoa.indicacao.token');

        if(tokenIndicacaoCampo && envConfig.tokenIndicacao) {

          const tokenIndicacaoResposta = {  
            campoCodigo: tokenIndicacaoCampo.codigo,
            campoId: tokenIndicacaoCampo.id,
            valor: envConfig.tokenIndicacao,
            ordem: "0",
          }

          respostas.push(tokenIndicacaoResposta);
        }

        requestBody = {
          produto: this.productId,
          origemComercial: envConfig.origemComercialId,
          respostas: compact(respostas).filter((item) => item.campoId !== -1),
          origem: "WHITELABEL",
          clienteNome: this.extrairNomeOuRazaoSocial(respostas, envConfig),
          clienteDocumento: this.extrairCpfOuCnpj(respostas, envConfig),
          fluxo: envConfig.consultaExternaConfig?.fluxoId || null
        };

        try {
          const recaptchaProvider = envConfig.captchaProvider;

          const captchaToken = await this.getCaptchaTokenByProvider(recaptchaProvider);

          const responseProposta: Proposta = await this.propostaService.inicio(
            requestBody,
            captchaToken?.replace(/"/g, ""),
            recaptchaProvider || ''
          );
          appState.proposta = responseProposta;
          this.localStorageService.saveAppState(appState);
          await this.router.navigate(["processamento"]);
          this.isLoading = false;
        } catch (err: any) {
          console.log(err);
          const message = this.messageService.getMessageFromError(err, envConfig);
          this.appFlowService.clearAppState();
          this.appFlowService.startApp();
          await this.urlParams.colocarParametrosURL();
          this.dialog.open(DialogComponent, {
            width: "250px",
              data: { title: "Oooops!", message: message },
              });
        }


      } else {
        requestBody = {
          etapaId: appState.proposta?.etapaAtual.id,
          propostaId: appState.proposta?.id,
          respostas: compact(respostas).filter((item) => item.campoId !== -1),
        };

        const response: Proposta = await this.propostaService.enviarCaptacao(requestBody);

        appState.proposta = response;

        this.localStorageService.saveAppState(appState);
        await this.router.navigate(["processamento"]);
        this.isLoading = false;
      }

    } catch (err) {
      console.error("Erro no envio da coleta: ", err);
      const envConfig = this.localStorageService.getEnvConfig();
      const message = this.messageService.getMessageFromError(err, envConfig);
      this.appFlowService.clearAppState();
      this.appFlowService.startApp();
      await this.urlParams.colocarParametrosURL();
      this.dialog.open(DialogComponent, {
        width: "250px",
        data: { title: "Oooops!", message: message },
        });  
    }
  }

  getCaptchaTokenByProvider(recaptchaProvider: string | undefined): Promise<string | null> {
    if(recaptchaProvider && recaptchaProvider === 'turnstile') {
      return new Promise((resolve) => resolve(this.captchaToken));
    } 
    return this.recaptchaV3Service.execute("continuar").toPromise();
  }

  async ngOnInit(): Promise<void> {
    this.isLoading = true;
    this.initReviewForm();
    this.captchaStorageService.watch().pipe(take(1)).subscribe((token) => {console.log("Token changed:", token); this.captchaToken = token});
    // if(this.router.url === "/revisar") this.router.navigate(["processamento"]);

    // this.recaptchaV3Service
    // .execute("enviarCaptacao")
    // .pipe(
    //   concatMap((token) => this.recaptchaSmileGoService.verify({token: token}))
    // )
    // .subscribe({
    //   next: response => {
    //     this.isLoading = !this.isLoading;
    //     this.initReviewForm()
    //   },
    //   error: response => {
    //     this.isLoading = !this.isLoading;
    //     this.router.navigate(["preenchimento"]);

    //     this.dialog.open(DialogComponent, {
    //       width: "250px",
    //       data: { title: "Oooops!", message: "Captcha inválido!" },
    //     });
    //   }
    // });
  }

  public onReloadPage(){
    this.router.navigate(["processamento"]);
  }

  private async initReviewForm() {
    this.images = await this.appFlowService.getAllImages().then((images) => images.reduce((acc: any, item: any) => {
      return { ...acc, [item.id]: item.base64 };
    }, {})
    );

    const appState: AppState = this.appFlowService.getAppState();
    const { form: currentForm } = appState;
    // deepclone to avoid mutation
    const form = JSON.parse(JSON.stringify(currentForm));

    delete form.tos;

    const groups = {};

    const fields = Object.keys(form).map((el) => ({
      key: el,
      ...form[el],
    }));

    fields.forEach((field) => {
      // @ts-ignore
      if (groups[field?.group]) {
        // @ts-ignore
        groups[field?.group] = [
          // @ts-ignore
          ...groups[field?.group],
          ...Object.keys(field.value).map((el) => ({
            ...field.value[el],
            key: field.key,
          })),
        ];
      } else {
        // @ts-ignore
        groups[field?.group] = Object.keys(field.value).map((el) => ({
          ...field.value[el],
          key: field.key,
        }));
      }
    });

    this.formData = Object.keys(groups).map((key) => {
      // @ts-ignore
      const group = groups[key];
      // @ts-ignore
      const values = [];

      // get values of each field
      Object.keys(group)
        .filter(
          (el) => group[el]?.tipo === "CAPTURA_IMAGEM" || !group[el].oculto
        )
        .map((el) => {
          const field = group[el];
          const value = field?.valor;

          if (value == null) {
            return;
          }
          values.push({
            name: field.titulo,
            field,
            type: field.tipo,
            link: field.key,
          });
        });

      return {
        title: key,
        // @ts-ignore
        values,
      };
    });

    const envConfig = this.localStorageService.getEnvConfig();

    if (envConfig.captacaoAutoEnvio)
      await this.submitForm();
  }

  getValue(field: any): any {
    let value = this.formGroup.getRawValue()[field.campoCodigo];
    if (!value) {
      return;
    }

    if (field?.tipo === "DECIMAL") {
      value = `R$ ${value}`;
    } else if (field?.tipo === "DATA") {
      value = new Date(value).toLocaleDateString();
    } else if (field?.tipo === "CAPTURA_IMAGEM") {
      value = ["data:image/png;base64,", this.images[value]].join("");
    }

    if (field?.campoCodigo.includes("cpf")) {
      value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    }

    let campoCodigo = (field as FormValue).campoCodigo;
    let campo = (this.fieldsMap as any)[campoCodigo] as Campo;
    if (campo.opcoes) {
      let opcaoSelecionada = campo.opcoes?.find((op) => op.valor == value);
      if (opcaoSelecionada) {
        value = opcaoSelecionada.titulo;
      }
    }

    return value;
  }

  cancelEdit(field: any): void {
    this.formGroup.controls[field.campoCodigo]?.setValue(field.valor);
    this.field = {};
  }

  onImageCapture(data: { image: string; appKey: string }): void {
    const base64 = data.image;
    const id = this.field.codigo || "";
    this.dbService.update("images", { base64, id }).subscribe((item: any) => {
      this.captureOpen = false;
      const codigo = this.field?.codigo;
      if (codigo) {
        this.images[codigo] = base64;
      }
      this.field = {};
    });
  }

  onCancel(event: Event): void {
    this.captureOpen = false;
  }

  async doEdit(field: any): Promise<void> {
    if (this.isValid(field)) {
      this.field = {};
    }
  }

  getFieldFromState(field: any) {
    const state = this.appFlowService.getAppState();
    let findFieldResult =
      state.fields[field.key].fields.find(
        (item) => item.codigo === field.campoCodigo
      ) || {};
    return findFieldResult;
  }

  getFieldAttribute(field: any, attributeName: string) {
    const fieldFromState = this.getFieldFromState(field);
    return fieldFromState.atributos?.find(
      (item) => item.propriedade === attributeName
    )?.valor;
  }

  edit(field: any): void {
    this.field = this.getFieldFromState(field);

    if (field.tipo === "CAPTURA_IMAGEM") {
      this.captureOpen = true;
    }
  }

  private dedupeRespostasByCampoId(respostas: any[]): any[] {
    const byCampoId = new Map<string | number, any>();
    for (const resposta of compact(respostas)) {
      if (resposta?.campoId == null || resposta.campoId === -1) {
        continue;
      }
      byCampoId.set(resposta.campoId, resposta);
    }
    return Array.from(byCampoId.values());
  }

  isPreProposta() {
    //COLETAARRAY
    return (
      this.appFlowService.getAppState().pages.some(page => page.match(/pre-proposta/ig))
    );
  }

  extrairCpfOuCnpj(respostas: any[], envConfig: EnvConfig): string{

    const documento = respostas.find(
      (item) => item.campoCodigo === (envConfig.productType ? envConfig.productType === ProductType.PJ ? envConfig.nomeCampoCnpj : envConfig.nomeCampoCpf : envConfig.nomeCampoCpf)
    )?.valor;

    return typeof documento === "string" ? documento.toUpperCase() : documento;

  }

  extrairNomeOuRazaoSocial(respostas: any[], envConfig: EnvConfig): string{
    return respostas.find(
      (item) => item.campoCodigo === (envConfig.productType ? envConfig.productType === ProductType.PJ ? envConfig.nomeCampoRazaoSocial : envConfig.nomeCampoNomeCliente : envConfig.nomeCampoNomeCliente)
    )?.valor;
  }

}
